const DEFAULT_MEASUREMENT_ID = "G-NQF5JSPQ0B";
const MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || DEFAULT_MEASUREMENT_ID;

const isBrowser = typeof window !== "undefined";
const TRACKING_SELECTOR = [
  "[data-analytics-action]",
  "[data-analytics-label]",
  "button",
  "a",
  "[role='button']",
  "input[type='button']",
  "input[type='submit']"
].join(", ");

const sanitizeText = value =>
  String(value || "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 100);

const sanitizeParams = params =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === "") {
      return acc;
    }

    acc[key] = typeof value === "string" ? sanitizeText(value) : value;
    return acc;
  }, {});

export const initAnalytics = () => {
  if (!isBrowser || window.ezprestaAnalyticsInitialized || !MEASUREMENT_ID) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, {
    send_page_view: false
  });

  window.ezprestaAnalyticsInitialized = true;
};

export const trackPageView = path => {
  if (!isBrowser) {
    return;
  }

  initAnalytics();

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isBrowser) {
    return;
  }

  initAnalytics();
  window.gtag("event", eventName, sanitizeParams(params));
};

export const getAnalyticsElementDetails = element => {
  if (!element || !element.closest) {
    return null;
  }

  const trackingElement = element.closest(TRACKING_SELECTOR);

  if (!trackingElement) {
    return null;
  }

  return sanitizeParams({
    action:
      trackingElement.dataset.analyticsAction ||
      trackingElement.getAttribute("type") ||
      "click",
    label:
      trackingElement.dataset.analyticsLabel ||
      trackingElement.getAttribute("aria-label") ||
      trackingElement.getAttribute("title") ||
      trackingElement.innerText ||
      trackingElement.value ||
      trackingElement.href,
    element_tag: trackingElement.tagName.toLowerCase(),
    element_id: trackingElement.id,
    element_classes: trackingElement.className,
    destination_url: trackingElement.href
  });
};
